import {
  getMaintance,
  getMaintanceSuccess,
  getMaintanceFailure,
} from './maintance.actions';
import { createReducer, on } from '@ngrx/store';
import { initialMaintanceState } from './maintance.state';

export const reducer = createReducer(
  initialMaintanceState,

  on(getMaintance, (state) => ({
    ...state,
    loading: true,
  })),
  on(getMaintanceSuccess, (state, { response }) => ({
    ...state,
    maintance: response,
    loading: false,
  })),
  on(getMaintanceFailure, (state, { error }) => ({
    ...state,
    maintance: null,
    loading: false,
  })),
);
